import { createBrowserHistory } from 'history';
import {
  applyMiddleware,
  createStore,
  compose,
  Middleware,
} from 'redux';
import logger from 'redux-logger';
import thunk, { ThunkMiddleware } from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer, { AppStates, AppActions } from '../reducers/root.reducer';

export const history = createBrowserHistory();

const middlewares: Middleware[] = [
  thunk as ThunkMiddleware<AppStates, AppActions>,
  routerMiddleware(history),
];

if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger);
}

const configureStore = (preLoadedState?: any) => {
  const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth'],
  };
  const store = createStore(
    persistReducer(persistConfig, rootReducer(history)),
    preLoadedState,
    compose(applyMiddleware(...middlewares)),
  );
  return store;
};

export default configureStore;
